import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '@vi-iot/client';
import { MockedVdd } from '@vi-iot/client/apis/remote-diagnostics/mocked-vdds/MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class HydraulicSeparatorTemperatureSensor implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES: ' 62 01 1A 54 03 4F 03 5A 03 4F 03 00',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0020_HPMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0020_HPMU_CAN01',
      request_parameter_value: VddNames.HydraulicSeparatorTemperatureSensor,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'HydraulicSeparatorTemperatureSensor',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'SENSORVALUE',
              path: 'PA_DataRecor/PA_Value',
              unit: '°C',
              translationid: 'TI_Value',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              name: 'PA_Value',
              value: '85.2',
            },
            {
              semantic: 'SENSORMIN',
              path: 'PA_DataRecor/PA_Min',
              unit: '°C',
              translationid: 'TI_Min',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              name: 'PA_Min',
              value: '84.7',
            },
            {
              semantic: 'SENSORMAX',
              path: 'PA_DataRecor/PA_Max',
              unit: '°C',
              translationid: 'TI_Max',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              name: 'PA_Max',
              value: '85.8',
            },
            {
              semantic: 'SENSORAVG',
              path: 'PA_DataRecor/PA_Avg',
              unit: '°C',
              translationid: 'TI_Avg',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              name: 'PA_Avg',
              value: '84.7',
            },
            {
              semantic: 'SENSORSTATUS',
              path: 'PA_DataRecor/PA_Statu',
              unit: '',
              translationid: 'TI_Status',
              dopname: '1 Byte TextTable SensorEnum',
              name: 'PA_Statu',
              value: 'NoError',
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 01 1A',
    };
  }
  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0020_HPMU_CAN01',
      request_parameter_value: VddNames.OutsideTemperatureSensor,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '282',
          value: 'HydraulicSeparatorTemperatureSensor',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'LOWLOWLEVEL',
              longname: 'LowLowLevel',
              byteposition: '0',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              precision: '1',
              byteLength: '16',
              type: 'eA_FLOAT32',
              shortname: 'PA_LowLowLevel',
              constraints: '[-3276.8:3276.7]',
              path: 'PA_Value/PA_LowLowLevel',
              unit: '°C',
              translationid: 'TI_LowLowLevel',
              bitposition: '0',
              name: 'PA_LowLowLevel',
              value: '0.0',
            },
            {
              semantic: 'LOWLEVEL',
              longname: 'LowLevel',
              byteposition: '2',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              precision: '1',
              byteLength: '16',
              type: 'eA_FLOAT32',
              shortname: 'PA_LowLevel',
              constraints: '[-3276.8:3276.7]',
              path: 'PA_Value/PA_LowLevel',
              unit: '°C',
              translationid: 'TI_LowLevel',
              bitposition: '0',
              name: 'PA_LowLevel',
              value: '5.0',
            },
            {
              semantic: 'HIGHLEVEL',
              longname: 'HighLevel',
              byteposition: '4',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              precision: '1',
              byteLength: '16',
              type: 'eA_FLOAT32',
              shortname: 'PA_HighLevel',
              constraints: '[-3276.8:3276.7]',
              path: 'PA_Value/PA_HighLevel',
              unit: '°C',
              translationid: 'TI_HighLevel',
              bitposition: '0',
              name: 'PA_HighLevel',
              value: '80.0',
            },
            {
              semantic: 'HIGHHIGHLEVEL',
              longname: 'HighHighLevel',
              byteposition: '6',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              precision: '1',
              byteLength: '16',
              type: 'eA_FLOAT32',
              shortname: 'PA_HighHighLevel',
              constraints: '[-3276.8:3276.7]',
              path: 'PA_Value/PA_HighHighLevel',
              unit: '°C',
              translationid: 'TI_HighHighLevel',
              bitposition: '0',
              name: 'PA_HighHighLevel',
              value: '127.0',
            },
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '8',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                {
                  TI_texttableentry: 'TI_False',
                  interval: '0',
                  texttableentry: 'False',
                },
                { TI_texttableentry: 'TI_True', interval: '1', texttableentry: 'True' },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'False',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }
  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0020_HPMU_CAN01',
          request_parameter_value: VddNames.OutsideTemperatureSensor,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '282',
              value: 'HydraulicSeparatorTemperatureSensor',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'SENSORVALUE',
                  longname: 'Value',
                  byteposition: '0',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_Value',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Struc/PA_Value',
                  unit: '°C',
                  translationid: 'TI_Value',
                  bitposition: '0',
                  name: 'PA_Value',
                  value: '0.0',
                },
                {
                  semantic: 'SENSORMIN',
                  longname: 'Min',
                  byteposition: '2',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_Min',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Struc/PA_Min',
                  unit: '°C',
                  translationid: 'TI_Min',
                  bitposition: '0',
                  name: 'PA_Min',
                  value: '0.0',
                },
                {
                  semantic: 'SENSORMAX',
                  longname: 'Max',
                  byteposition: '4',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_Max',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Struc/PA_Max',
                  unit: '°C',
                  translationid: 'TI_Max',
                  bitposition: '0',
                  name: 'PA_Max',
                  value: '0.0',
                },
                {
                  semantic: 'SENSORAVG',
                  longname: 'Avg',
                  byteposition: '6',
                  dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                  precision: '1',
                  byteLength: '16',
                  type: 'eA_FLOAT32',
                  shortname: 'PA_Avg',
                  constraints: '[-3276.8:3276.7]',
                  path: 'PA_Struc/PA_Avg',
                  unit: '°C',
                  translationid: 'TI_Avg',
                  bitposition: '0',
                  name: 'PA_Avg',
                  value: '0.0',
                },
                {
                  semantic: 'SENSORSTATUS',
                  longname: 'Status',
                  byteposition: '8',
                  dopname: '1 Byte TextTable SensorEnum',
                  precision: '',
                  byteLength: '8',
                  type: 'eTEXTTABLE',
                  shortname: 'PA_Statu',
                  constraints: '',
                  structure: [
                    {
                      TI_texttableentry: 'TI_NoError',
                      interval: '0',
                      texttableentry: 'NoError',
                    },
                    {
                      TI_texttableentry: 'TI_Interruption',
                      interval: '1',
                      texttableentry: 'Interruption',
                    },
                    {
                      TI_texttableentry: 'TI_ShortCircuit',
                      interval: '2',
                      texttableentry: 'ShortCircuit',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalFault',
                      interval: '3',
                      texttableentry: 'ElectricalFault',
                    },
                    {
                      TI_texttableentry: 'TI_NotAvailable',
                      interval: '4',
                      texttableentry: 'NotAvailable',
                    },
                    {
                      TI_texttableentry: 'TI_Invalidates',
                      interval: '5',
                      texttableentry: 'Invalidates',
                    },
                  ],
                  path: 'PA_Struc/PA_Statu',
                  unit: '',
                  translationid: 'TI_Status',
                  bitposition: '0',
                  name: 'PA_Statu',
                  value: 'NoError',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
